import { VectorUpIcon } from '@/assets/icons';
import React, { ReactNode } from 'react';
import ButtonWrap from '../ButtonWrap';
import IconWrap from '../IconWrap';
import './style.scss';

interface IProps {
    onClick: (type: 'prev' | 'next') => void;
    disabledPrev?: boolean;
    disabledNext?: boolean;
    onlyPrev?: boolean;
    onlyNext?: boolean;
    width?: number | string;
    children?: ReactNode;
    name?: string;
}

const ButtonScroll: React.FC<IProps> = ({
    onClick,
    disabledPrev,
    disabledNext,
    onlyPrev,
    onlyNext,
    width,
    children,
    name,
}) => {
    if (onlyPrev) {
        return (
            <div className="c-button-scroll">
                <ButtonWrap
                    id={`c-button-scroll--prev-${name}`}
                    className="c-button-scroll--prev c-button-scroll--prev--only --active"
                    onClick={() => onClick('prev')}
                    icon={<VectorUpIcon />}
                    disabled={disabledPrev}
                    width={width}
                />
            </div>
        );
    }
    if (onlyNext) {
        return (
            <div className="c-button-scroll">
                <ButtonWrap
                    id={`c-button-scroll--next-${name}`}
                    className="c-button-scroll--next c-button-scroll--next--only --active"
                    onClick={() => onClick('next')}
                    icon={<VectorUpIcon />}
                    disabled={disabledNext}
                    width={width}
                />
            </div>
        );
    }
    return (
        <div className="c-button-scroll">
            <ButtonWrap
                id={`c-button-scroll--prev-${name}`}
                className="c-button-scroll--prev --active"
                onClick={() => onClick('prev')}
                icon={<IconWrap icon={<VectorUpIcon />} />}
                disabled={disabledPrev}
                width={width}
            />
            {children}
            <ButtonWrap
                id={`c-button-scroll--next-${name}`}
                className="c-button-scroll--next --active"
                onClick={() => onClick('next')}
                icon={<IconWrap icon={<VectorUpIcon />} />}
                disabled={disabledNext}
                width={width}
            />
        </div>
    );
};

export default React.memo(ButtonScroll);
